import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material'

export function GameCreators({
  open,
  handleClose,
}: {
  open: boolean
  handleClose: () => void
}) {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 4,
          width: isLargeScreen ? 400 : '80%',
          p: 3,
        }}
      >
        <Typography variant="h5" component="h2">
          Yarncat LTD
        </Typography>
        <Typography variant="subtitle1">
          We are a small company registed in the UK, consisting of a pair of
          developer and designer who love to create games, utilitarian apps and
          prototype ideas. We build our apps with love, and consideration to our
          users.
        </Typography>
        <ListItem sx={{ mt: 2 }}>
          <Avatar
            sx={{ width: 56, height: 56, mr: 1 }}
            src={`${process.env.PUBLIC_URL}/images/creator_maulashree.jpg`}
          ></Avatar>
          <ListItemText
            primary="Maulashree Shanbhag"
            secondary="Founder · UX Designer · Artist"
          />
        </ListItem>
        <ListItem sx={{ mb: 2 }}>
          <Avatar
            sx={{ width: 56, height: 56, mr: 1 }}
            src={`${process.env.PUBLIC_URL}/images/creator_bijoy.jpg`}
          ></Avatar>
          <ListItemText
            primary="Bijoy S Kochar"
            secondary="Director · Software Engineer · Game Designer"
          />
        </ListItem>
        <Typography variant="caption">
          This website is © Yarncat LTD 2025
        </Typography>
      </Box>
    </Modal>
  )
}
